import { render, staticRenderFns } from "./Heroes.view.vue?vue&type=template&id=1f0ed14e&scoped=true&lang=pug&"
import script from "./Heroes.view.vue?vue&type=script&lang=js&"
export * from "./Heroes.view.vue?vue&type=script&lang=js&"
import style0 from "./Heroes.view.vue?vue&type=style&index=0&id=1f0ed14e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ed14e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCard,VCardText})
